import axios from 'axios';
import router from '../router/index';
import Common from '../../static/js/common.js';
import SignRequest from '@/utils/SignRequest';

//创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // api的base_url
    timeout: 15000, // 请求超时时间
})

//request拦截器
service.interceptors.request.use(config => {
    const timeStamp = Date.parse(new Date()) / 1000;

    config.headers['AppId'] = "al@jusocvhx0cokwxif";
    config.headers['Token'] = SignRequest.getToken() || ''
    config.headers['Sign'] = SignRequest.getSign(config.url, timeStamp);
    config.headers['MethodName'] = config.url;
    config.headers['Content-Type'] = "application/json ; charset=utf-8";
    config.headers['TimeStamp'] = timeStamp;
    return config
}, error => {
    console.log('request error', error);
    Promise.reject(error)
})

//respone拦截器
// config: {
//  isHasErrorOther: true, 错误的其他操作（例如：不显示错误提示，或者根据Msg实施其他操作）
// }
service.interceptors.response.use(
    response => {
        const {data, config} = response;
        if (data.Code == '100') {
            // 请求成功
            return data;
        } else {
            // 请求失败
            console.log('then error', data.Msg);
            if(data.Msg && !config.isHasErrorOther) Common.toast(data.Msg);
            return Promise.reject(data);
        }
    },
    error => {
        console.log('catch error', error);
        if (error.response.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("mid");
            localStorage.removeItem("beforeLoginUrl");
            localStorage.beforeLoginUrl = window.location.href;
            Common.showMsg('请登录', function () {
                // 跳转登录页面
                router.push('/codeLogin');
            })
        }
        return Promise.reject(error)
    }
)

export default service